export default __webpack_public_path__ + "static/media/DT.cf1f1f16.svg";